/*
 * @Author: Musa Tabitay
 * @Date: 2019-11-12 22:49:22
 * @LastEditTime: 2022-05-02 15:12:07
 */
import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'

Vue.use(Router)

export default new Router({
  base: '/dist/',
  routes: [{
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    redirect: {
      path: '/course'
    },
    children: [{
      path: 'swiper',
      name: 'Swiper',
      component: () => import('../views/Swiper.vue')
    },
    {
      path: 'category',
      name: 'Category',
      component: () => import('../views/Category.vue')
    },
    {
      path: 'course',
      name: 'Course',
      component: () => import('../views/Course.vue')
    },
    {
      path: 'lesson/:id/:title/:type',
      name: 'Lesson',
      component: () => import('../views/Lesson.vue')
    },
    {
      path: 'information',
      name: 'Information',
      component: () => import('../views/Information.vue')
    },
    {
      path: 'member',
      name: 'member',
      component: () => import('../views/Member.vue')
    },
    {
      path: 'vip',
      name: 'vip',
      component: () => import('../views/Vip.vue')
    },
    {
      path: 'users',
      name: 'Users',
      component: () => import('../views/Users.vue')
    },
    {
      path: 'order',
      name: 'Order',
      component: () => import('../views/Order.vue')
    },
    {
      path: 'short_video',
      name: 'short_video',
      component: () => import('../views/ShortVideo.vue')
    },
    {
      path: 'about',
      name: 'about',
      component: () => import('../views/About.vue')
    },
    {
      path: 'agree',
      name: 'agree',
      component: () => import('../views/Agree.vue')
    },
    {
      path: 'guide',
      name: 'guide',
      component: () => import('../views/Guide.vue')
    },
    {
      path: 'teacherList',
      name: 'teacherList',
      component: () => import('../views/Teacher.vue')
    },
    {
      path: 'topic',
      name: 'topic',
      component: () => import('../views/Topic.vue')
    },
    {
      path: 'wechatconfig',
      name: 'wechatconfig',
      component: () => import('../views/WechatConfig.vue')
    },
    {
      path: 'material',
      name: 'material',
      component: () => import('../views/Tencent/Materials')
    },
    {
      path: 'appreciates',
      name: 'appreciates',
      component: () => import('../views/Appreciates.vue')
    },
    {
      path: 'activity',
      name: 'activity',
      component: () => import('../views/Activity.vue')
    },
    {
      path: 'activityList',
      name: 'activityList',
      component: () => import('../views/ActivityList.vue')
    }
    ]
  }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js